import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useFormField } from 'cng-common/features/form'
import { selectExportSlides } from 'partner360/features/QBR/selectors/selectExportSlides'
import { ISlideSection } from 'partner360/models/qbr/ISlideSection'

import { QBR_SETTINGS_FORM_KEY } from '../../../../settingsStep/components/qbrSettingsForm'
import { getExportSlides } from '../helpers/getExportSlides'

export const useFormExportSlides = () => {
  /** -------------------- Selectors ----------------------- */

  const initialExportSlides = useSelector(selectExportSlides)

  /** -------------------- Hooks ----------------------- */

  const {
    value: storedExportSlides,
    handleChange,
    isModified: isExportSlidesModified,
  } = useFormField({
    formKey: QBR_SETTINGS_FORM_KEY,
    field: 'exportSlides',
    defaultValue: initialExportSlides,
  })

  /** -------------------- Variables ----------------------- */

  const exportSlides = useMemo(() => {
    return getExportSlides(storedExportSlides)
  }, [storedExportSlides])

  /** -------------------- Methods ----------------------- */

  const onChangeExportSlide = useCallback(
    async (slideSection: ISlideSection) => {
      const modifiedExportSlides = getExportSlides(storedExportSlides, [slideSection])

      await handleChange(modifiedExportSlides)
    },
    [handleChange, storedExportSlides]
  )

  return {
    exportSlides,
    onChangeExportSlide,
    isExportSlidesModified,
  }
}
